import { z } from 'zod';

export const E2eMail = z.object({
  to: z.string().array(),
  from_email: z.string(),
  subject: z.string(),
  body: z.string(),
});

export type E2eMail = z.infer<typeof E2eMail>;
